<template>
  <div id="app" :class="{ menuOpen: toggleMainSidebar == true }">
    <TheSideNav />
    <el-container class="fullContainer">
      <div class="sidemenu-left-box">
        <el-aside class="sidemenu-left" width="299px">
          <MenuSide />
          <!--left side bar-->
        </el-aside>
      </div>
      <div class="mincontainer">
        <el-container>
          <el-header>
            <Header />
          </el-header>
          <el-main>
            <router-view />
          </el-main>
          <el-footer>
            <Footer />
          </el-footer>
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/Header.vue"
import Footer from "@/components/Footer.vue"
import TheSideNav from "@/components/TheSideNav"
import MenuSide from "@/components/MenuSide.vue"
import { store } from "@/store/store"

export default {
  name: "MainLayout",
  mounted() {},
  components: {
    Header,
    MenuSide,
    TheSideNav,
    Footer,
  },
  data() {
    return {}
  },
  beforeCreate() {
    // for disable spinner
    //store.state.clearGlobalSpinnerInterval = setInterval(() => { Style.clearGlobalSpinner(document) }, 3000)
  },
  computed: {
    toggleMainSidebar() {
      return store.state.toggleMainSidebar
    },
  },
}
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: "Segoe UI", "Microsoft JhengHei", "Microsoft YaHei", "Arial";
  font-size: 14px;
}
body {
  background-color: #efefef;
}
body .el-input.is-disabled .el-input__inner {
  color: #606266;
}
.boxContain {
  margin: 10px 0;
}
.el-header {
  padding: 0;
  z-index: 100;
}
.el-aside {
  background-color: #fff;
  text-align: center;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
}
.el-main {
  box-sizing: border-box;
  padding: 20px 0px 100px 0px;
  width: 80%;
  margin: 0 auto;
}
.el-footer {
  height: 50px !important;
  padding: 0;
}
body .el-select {
  width: 100%;
}
body .el-date-editor {
  width: 100%;
}
.mincontainer {
  box-sizing: border-box;
  width: 100%;
}
.mincontainer > .el-container > .el-main {
  padding-bottom: 20px;
}
.menuOpen .mincontainer {
  padding-left: 300px;
}

.fullContainer.sidemenu-close .sidemenu-left {
  transition: all 0.3s ease-out;
  transform: translateX(-300px);
}

.fullContainer.sidemenu-close .mincontainer {
  padding-left: 0px;
}
.fullContainer.sidemenu-close .fixed-top {
  left: 0px;
}

.menuOpen .sidemenu-left-box {
  transform: translateX(0px);
}
.sidemenu-left-box {
  transition: all 0.1s ease-out;
  transform: translateX(-300px);
  position: fixed;
  top: 0;
  bottom: 0;
}
h3 {
  color: #009ae0;
  margin: 0.5rem 0;
}
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
/*Bottons*/
.orange-button,
.orange-button:focus {
  /*background: #0a64a1;*/
  background: #e6a23c;
  color: #fff;
  border-color: #845b1f;
  outline: none;
  ox-shadow: none;
  box-shadow: 0 2px #845b1f;
}
.orange-button:hover {
  background: #ca8b2e;
  color: #fff;
  border-color: #845b1f;
}
.orange-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px #845b1f;
}
.button-right {
  float: right;
}

.blue-button,
.blue-button:focus {
  /*background: #0a64a1;*/
  background: #50c9ff;
  color: #fff;
  border-color: #009ae0;
  outline: none;
  ox-shadow: none;
  box-shadow: 0 2px #0077ad;
}
.blue-button:hover {
  background: #20b9ff;
  color: #fff;
  border-color: #009ae0;
}
.blue-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px #0077ad;
}
.buttons {
  overflow: hidden;
}
body .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
@media (max-width: 1025px) {
  .sidemenu-left {
    display: none;
  }
  .el-main {
    padding: 20px;
  }
  .menuOpen .mincontainer {
    padding-left: 0px;
    /*background: #000000;*/
  }
  .menu-side:not(.el-menu--collapse) {
    width: 240px;
    /*border-right: solid 0px #e6e6e6;*/
  }
  .menuSideTopBox {
    display: none;
  }
  #app .nav-item {
    border-top: 1px #ccc solid;
    border-bottom: 1px #ccc solid;
    margin: 50px 0 10px 0;
    padding: 10px 0 10px 10px;
  }
  #app .nav-item span {
    color: #000000;
  }
  #app .menu-side {
    top: 150px;
    background-color: none;
  }
  .menu-side-title {
    display: none;
  }
  #app .sidenav {
    background-color: #fff;
  }
  #app .menuitem {
    background-color: red;
  }
  .sidenav li > div > span {
    background-color: #0089c8;
  }
  .el-row .el-col-12 {
    width: 100%;
  }
  h3.includeBtn {
    margin-top: 30px;
  }
  .boxContain.includeBtn .c-table-top-right-btn {
    position: absolute;
    top: -50px;
    right: 0px;
  }
}
</style>
